module.exports = __webpack_public_path__ + "img/Contract.24ef1672.svg";